import clsx from "clsx";
import type { ReactNode } from "react";

interface ListRowProps {
  children: ReactNode;
  className?: string;
}

/**
 * Compact list-row shell for repeated items on list pages (mobile-first).
 * 44px min height keeps the row a valid touch target; sm+ restores the
 * previous roomier card padding.
 */
export default function ListRow({ children, className }: ListRowProps) {
  return (
    <div
      className={clsx(
        "bg-white rounded-lg border border-secondary-200 min-h-11 px-3 py-2.5 sm:px-5 sm:py-3.5",
        className,
      )}
    >
      {children}
    </div>
  );
}
